


import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { SpecialistsService } from 'src/app/services/v2/users/specialists.service';

@Component({
  selector: 'app-specialists',
  templateUrl: './specialists.component.html',
  styleUrl: './specialists.component.scss'
})
export class SpecialistsComponent implements OnInit {
  protected locale:string = this.languageService.getLanguage();
  public specialists:Array<any> = [];
  public loading:boolean = true;
  constructor(private languageService: LanguageService,
            private specialistsService: SpecialistsService) { }

  ngOnInit(): void {
    this.getSpecialists();
  }

  getSpecialists() {
    this.specialistsService.getSpecialists().subscribe((res) => {
      this.specialists = res;
      console.log(this.specialists)
      this.loading = false;
    })
  }

}
